import React from "react";
import { Box, Typography } from "@mui/material";
import { homeSectionPaper } from "./homeStyles";

const HomeSection = ({
  title,
  subtitle,
  action,
  children,
  noPadding = false,
  id,
  sx = {},
}) => (
  <Box component="section" id={id} sx={{ mb: 3, ...sx }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        mb: 1.5,
        gap: 2,
      }}
    >
      <Box>
        <Typography variant="h6" component="h2" fontWeight={600}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {action}
    </Box>
    <Box sx={{ ...homeSectionPaper, p: noPadding ? 0 : 2 }}>{children}</Box>
  </Box>
);

export default HomeSection;
